export const EMPTY_RECALCULATION_FORM = {
  category_ids: [],
};

const RECALCULATION_SCOPE_BY_TARGET = {
  scope1: 'scope1',
  scope2: 'scope2',
  cat3: 'scope3',
  scope3_af: 'scope3',
  cat5: 'scope3',
  cat19: 'scope3',
  cat8: 'scope3',
};

const RECALCULATION_SCOPE_ORDER = ['scope1', 'scope2', 'scope3'];

export function canOpenRecalculationDialog(isAdmin) {
  return Boolean(isAdmin);
}

export function groupRecalculationCategories(categories = []) {
  return RECALCULATION_SCOPE_ORDER.map((scope) => ({
    id: scope,
    items: categories.filter((item) => RECALCULATION_SCOPE_BY_TARGET[item.id] === scope),
  })).filter((group) => group.items.length > 0);
}

export function toRecalculationForm() {
  return { ...EMPTY_RECALCULATION_FORM, category_ids: [] };
}

export function toRecalculationPayload(values) {
  return {
    targets: [...values.category_ids],
  };
}
